import { forwardRef } from "react";
function SvgMicrosoft({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 40 40"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path fill="#F25022" d="M19.478 8H8v11.478h11.478V8Z" />
      <path fill="#00A4EF" d="M19.478 20.522H8V32h11.478V20.522Z" />
      <path fill="#7FBA00" d="M32 8H20.522v11.478H32V8Z" />
      <path fill="#FFB900" d="M32 20.522H20.522V32H32V20.522Z" />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgMicrosoft);
export default ForwardRef;
